import React, { useState, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { useNavigate } from 'react-router-dom';
import { clearYourTownloopSearchValue } from '@/store/slices/searchBarSlice';
import { getProductFromOrder, getSuggestProductList,getOrderCount,getOrderPageList } from '@/api/order';
import YourTownloopProductList from '../../components/YourTownloopProductList/YourTownloopProductList2';
import YourTownloopSuggestList from '../../components/YourTownloopProductList/YourTownloopSuggestList';

import { eventBus } from '@/utils/eventBus';
import styles from './YourTownloopHome.module.scss';
import icon1 from '@/assets/images/路径 5.png';
import icon2 from '@/assets/images/f923e0a7c2352a805bf3ba894de6a74.png';
import { useTranslation } from 'react-i18next';
const YourTownloopHome: React.FC = () => {
   const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  //yourTownloopSearchValue关键字
  const yourTownloopSearchValue = useAppSelector((state) => state.searchBar.yourTownloopSearchValue);

  // 用户信息
  const userInfo = useAppSelector((state) => state.user.userInfo);

  

  //消费券
  const [couponInfo, setCouponInfo] = useState({
    redPacket: '$0',
    zeroCoupon: 'Zero coupons',
    coinDeduct: 'Coins deduct zero dollars',
    voucher: 'Zero - yuan',
    voucherName: 'consumption voucher',
    invalid: 'Invalid after 00:00:00',
  });

  // 订单状态
  const [orderStatus, setOrderStatus] = useState([
    { label: 'PendingPayment', value: 0, status: 1 },
    { label: 'Paid', value: 0, status: 3 },
    { label: 'Completed', value: 0, status: 5 },
    { label: 'Cancelled', value: 0, status: 2 },
  ]);

  // 商品信息
  const [products, setProducts] = useState<any[]>([]);

  // 商品推荐
  const [suggestions, setSuggestions] = useState<any[]>([]);

  //获取商品id
  const getId = (id: string) => {
    navigate(`/ProductDetail/${id}`);
  }

  //mounted 和unmounted
  useEffect(() => {

    // 如果用户已登录，获取订单数据
    if (userInfo) {
      getOrderCount().then((res) => {
        if (res.code == 200) {
          // 根据新的接口数据结构处理订单统计
          const statusCount = res.data?.product_order_status_count || {};
          // 计算所有订单状态的总和
          const totalCount = Object.values(statusCount).reduce((sum: number, count: any) => sum + (count || 0), 0);
          
          const orderStatus = [
            { label: 'All', value: totalCount, status: 0 },        // 全部
            { label: 'PendingPayment', value: statusCount['1'] || 0, status: 1 },        // 待支付 Unpaid
            { label: 'Cancelled', value: statusCount['2'] || 0, status: 2 },      // 已取消 Cancelled
            { label: 'Paid', value: statusCount['3'] || 0, status: 3 },          // 已支付/待发货 Paid
            { label: 'Completed', value: statusCount['5'] || 0, status: 5 },     // 已完成 Completed
         
          ];
          setOrderStatus(orderStatus);
        }
      });
    }

    getOrderPageList({order_status:3}).then((res)=>{
      if(res.code == 200){
        setProducts(res.data);
      }
    })

    getSuggestProductList({num:5}).then((res)=>{
      if(res.code == 200){
        console.log(res.data,'res.data推荐商品');
        setSuggestions(res.data);
      }
    })

    return () => {
      console.log('组件销毁时');
      //销毁清除townloopSearchValue的值
      eventBus.emit('deleteTownloopSearchValue');
      dispatch(clearYourTownloopSearchValue());
    }
  }, [userInfo]);

  //yourTownloopSearchValue关键字的监听
  useEffect(() => {
    console.log('YourTownloopHome组件yourTownloopSearchValue', yourTownloopSearchValue);

  }, [yourTownloopSearchValue])

  return (
    <div className={styles['home-root']}>
      {/* 用户信息卡片 */}
      <div className={styles['user-card']}>
        <div className={styles['user-info']}>
          <img className={styles['avatar']} src={userInfo?.photo || icon2} alt="avatar" />
          <div className={styles['user-meta']}>
            <div className={styles['user-name']}>{userInfo?.nick_name || ''}</div>
            <div className={styles['user-id']}>{userInfo?.first_name+ '' +userInfo?.last_name} <span className={styles['divider']}>|</span> <span>{userInfo?.username || ''}</span></div>
            {/* <div className={styles['user-desc']}>{userInfo.desc}</div> */}
          </div>
        </div>
        {
          false &&
          <div className={styles['coupon-info']}>
            <div className={styles['coupon-row']}>
              <span>{t("YourTownloopHome.Redpacket")} {couponInfo.redPacket}</span>
                <span>{t("YourTownloopHome.Zerocoupons")}</span>
              <span>{t("YourTownloopHome.Coinsdeduct")}</span>
            </div>
            <div className={styles['voucher-row']}>
              <div className={styles['voucher-info-box']}>
                <img src={icon1} alt="" />
                <div className={styles['voucher-info']}>
                  <div className={styles['voucher-title']}>
                    {couponInfo.voucher}
                    <span>{couponInfo.voucherName}</span>
                  </div>
                  <div className={styles['voucher-invalid']}>{couponInfo.invalid}</div>
                </div>
              </div>

              <button className={styles['voucher-btn']}>{t("YourTownloopHome.GoUseIt")}</button>
            </div>
          </div>
        }

      </div>

      {/* 订单区块 */}
      <div className={styles['orders-block']}>
         <div className={styles['orders-title-list']}>
            <div className={styles['orders-title']}>{t("YourTownloopHome.MyOrders")}</div>
            <div className={styles['orders-status-list']}>
              {orderStatus.map((item, idx) => (
                <div 
                  className={styles['order-status-item']} 
                  key={idx}
                  onClick={() => navigate(`/yourtownloop/orders?status=${item.status}`)}
                >
                  <div className={styles['order-status-value']}>{item.value}</div>
                  <div className={styles['order-status-label']}>{t('YourTownloopHome.'+item.label)}</div>
                </div>
              ))}
            </div>
         </div>
        {/* <YourTownloopProductList products={products} getId={getId}></YourTownloopProductList> */}
      </div>

      {/* 推荐区块 */}
      <div className={styles['suggest-title']}>{t("YourTownloopHome.SuggestedForYou")}</div>
      <YourTownloopSuggestList products={suggestions} getId={getId}></YourTownloopSuggestList>
    </div>
  );
};

export default YourTownloopHome; 